import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const EMAIL_REGEX = String.raw`[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}`;

export const DEFAULT_MODAL_OPTIONS: NgbModalOptions = {
  size: 'md',
  scrollable: true,
  centered: true,
  backdrop: 'static',
  keyboard: false,
};

export const FULLSCREEN_MODAL_OPTIONS: NgbModalOptions = {
  size: 'md',
  scrollable: true,
  centered: true,
  backdrop: 'static',
  keyboard: false,
  backdropClass: 'fullscreen',
};

export const DEFAULT_PAGE_SIZE = 30;
